// import React, { useEffect, useState } from "react";
import React, { useState } from "react";
import { useStyles } from "../../assets/jss/SearchBar";
import clsx from "clsx";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomDivider from "../CustomComponents/CustomDivider/CustomDivider";
import CustomIconButton from "../CustomComponents/CustomIconButton/CustomIconButton";
import CustomInputBase from "../CustomComponents/CustomInputBase/CustomInputBase";
import CustomPopover from "../CustomComponents/CustomPopover/CustomPopover";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import {
    CustomRadio,
    CustomRadioGroup,
} from "../CustomComponents/CustomRadio/CustomRadio";
import CustomFormControlLabel from "../CustomComponents/CustomFormControlLabel/CustomFormControlLabel";
import CustomAvatar from "../CustomComponents/CustomAvatar/CustomAvatar";
import { getInitials } from "../../assets/helperFunctions";
import { adminSearchSuggestion } from "../../services/AdminSearchService";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import DownArrow from "../../assets/images/downArrow.svg";
import SearchIcon from "../../assets/images/searchIcon.svg";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { useHistory, Link } from "react-router-dom";
import {
    EntityAccess,
    RBAC_CODE,
    RecordStatus,
    Role,
    SearchCriteria,
} from "../../config/app-globals.enum";
import { getSearchType, getUserRBAC } from "../../services/LocalStorageService";
import { Trans, useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";

const useAvatarStyles = makeStyles(theme => ({
    divider: {
        height: "28px",
        margin: "4px",
    },
    searchAvatar: {
        margin: theme.spacing(0, 3.0),
        [theme.breakpoints.down("sm")]: {
          margin: theme.spacing(0, 1.5),
        },
    },
    root: {
        "& .MuiAvatar-root": {
            backgroundColor: '#000000!important',
            color: 'white!important',
            width: "30px",
            height: "30px",
            fontSize: '.85rem',
        }
    }
}));

export default function SearchBar(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const avatarClasses = useAvatarStyles();
    const [getRBAC_AdminSearchResultView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_SEARCH_RESULT_VIEW, props)
    );
    const history = useHistory();
    const [anchorElSearchDropdown, setAnchorElSearchDropdown] =
        React.useState(null);
    const [dropdownValue, setDropdownValue] = React.useState({
        value: "0",
        label: t("ALL"),
        placeholder: t("SEARCH_FOR_USERS_AND_GROUPS"),
    });
    const [searchKey, setSearchKey] = React.useState("");
    const [searchResultPopoverOpen, setSearchResultPopoverOpen] =
        React.useState(false);
    const [isApiFailed, setIsApiFailed] = React.useState(null);
    const [isApi, setIsApi] = React.useState(null);
    const [statusValue, setStatusValue] = React.useState();
    const [apiResponseMessage, setApiResponseMessage] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [searchCriteria] = React.useState(getSearchType);
    const [searchSuggestionData, setSearchSuggestionData] = React.useState(null);

    const changeApiStatusCodeFunc = (status) => {
        if (
            status.code &&
            status.code !== 0 &&
            status.code !== 200 &&
            status.code !== 201
        ) {
            setApiResponseMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    async function getSearchSuggestionResult(event) {
        setStatusValue(null);
        setAlertMessage("");
        setIsApi(true);
        const data = await adminSearchSuggestion({
            searchString: event.target.value,
            searchType: dropdownValue.value,
        });
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setSearchSuggestionData(data.content);
            if (!data.content.length) {
                setApiResponseMessage(
                    t("NO_RESULT_FOUND_FOR_YOUR_SEARCH_CRITERIA")
                );
            }
            setIsApi(false);
            setIsApiFailed(false);
        } else {
            setIsApi(false);
            setIsApiFailed(true);
            changeApiStatusCodeFunc(data.status);
        }
    }

    const handleSearchChange = (event) => {
        setSearchKey(event.target.value);
        if (
            event.target.value &&
            event.target.value.length &&
            event.target.value.length >=
            process.env.REACT_APP_ADMIN_MIN_SEARCH_KEY_COUNT
        ) {
            getSearchSuggestionResult(event);
            setSearchResultPopoverOpen(true);
        } else if (
            (!event.target.value ||
                event.target.value.length <
                process.env.REACT_APP_ADMIN_MIN_SEARCH_KEY_COUNT) &&
            searchResultPopoverOpen
        ) {
            setSearchResultPopoverOpen(false);
        }
    };

    const getSearchResult = (e) => {
        if (
            getRBAC_AdminSearchResultView &&
            getRBAC_AdminSearchResultView.isAccessible === EntityAccess.ALLOWED
        ) {
            const adminSearchUrl = "/admin/search";
            const adminSearchParam = `?searchKey=${searchKey}&searchType=${dropdownValue.value}`;
            history.push(`${adminSearchUrl}${adminSearchParam}`, {
                from: history.location,
            });
        } else {
            e.preventDefault();
        }
        // if (
        //   searchKey &&
        //   searchKey.length >= process.env.REACT_APP_ADMIN_MIN_SEARCH_KEY_COUNT
        // ) {
        //   const adminSearchUrl = "/admin/search";
        //   const adminSearchParam = `?searchKey=${searchKey}&searchType=${dropdownValue.value}`;
        //   history.push(`${adminSearchUrl}${adminSearchParam}`, {
        //     from: history.location,
        //   });
        // } else {
        //   e.preventDefault();
        // }
    };

    const handleDropdownChange = (event) => {
        const selectedSearchTerm = searchCriteria.find(
            (item) => item.value === event.target.value
        );
        setDropdownValue(selectedSearchTerm);
    };

    const handleSearchDropdownClick = (event) => {
        setAnchorElSearchDropdown(event.currentTarget);
    };

    const handleSearchDropdownClose = () => {
        setAnchorElSearchDropdown(null);
    };
    const searchDropdownOpen = Boolean(anchorElSearchDropdown);
    const searchDropdownId = searchDropdownOpen
        ? "search-dropdown-popover"
        : undefined;

    React.useEffect(() => {
        if (searchResultPopoverOpen) {
            window.addEventListener("click", function (e) {
                if (
                    document.getElementById("searchBarWrapper") &&
                    document.getElementById("searchBarWrapper").contains(e.target as HTMLElement)
                ) {
                    return;
                } else {
                    setSearchResultPopoverOpen(false);
                }
            });
        } else {
            window.removeEventListener("click", function (e) { });
        }
    }, [searchResultPopoverOpen]);

    React.useEffect(() => {
        if (props.searchKey) {
            setSearchKey(props.searchKey);
        }
    }, [props.searchKey]);
    React.useEffect(() => {
        if (props.searchType) {
            const selectedSearchTerm = searchCriteria.find(
                (item) => item.value === props.searchType
            );
            setDropdownValue(selectedSearchTerm);
        }
    }, [props.searchType]);

    const [origin, setOrigin] = useState<any>({
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: "left",
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: "left",
        },
    });

    const divRef = React.useRef();

    return (
        <div ref={divRef}>
            <CustomBox className={classes.searchBarWrapper}>
                <CustomPaper
                    id="searchBarWrapper"
                    component="form"
                    onSubmit={getSearchResult}
                    className={clsx(
                        classes.searchBarInnerWrapper,
                        searchResultPopoverOpen && classes.searchBarInnerWrapperOpen,
                        props && props.size && props.size === "small"
                            ? classes.searchBarInnerWrapperSmall
                            : null
                    )}
                    square
                    elevation={0}
                >
                    <CustomBox
                        className={classes.iconButton}
                        aria-label="search dropdown"
                        aria-describedby={searchDropdownId}
                        variant="contained"
                        onClick={handleSearchDropdownClick}
                    >
                        <span className={classes.selectedSearchText}>
                            {dropdownValue.label}
                        </span>{" "}
                        <img
                            src={DownArrow}
                            alt="Down Arrow"
                            className={classes.downArrow}
                        />
                    </CustomBox>
                    <CustomPopover
                        id={searchDropdownId}
                        open={searchDropdownOpen}
                        anchorEl={anchorElSearchDropdown}
                        onClose={handleSearchDropdownClose}
                        anchorOrigin={origin.anchorOrigin as Number}
                        transformOrigin={origin.transformOrigin as Number}
                    >
                        <CustomBox className={classes.searchDropdownWrapper}>
                            <CustomRadioGroup
                                aria-label="searchCriteria"
                                name="searchCriteria"
                                value={dropdownValue.value}
                                onChange={handleDropdownChange}
                            >
                                {searchCriteria && searchCriteria.length
                                    ? searchCriteria.map((item, index) => {
                                        return (
                                            <CustomFormControlLabel
                                                key={`${index}-searchCriteria-${item.label}`}
                                                value={item.value}
                                                control={<CustomRadio color="primary" />}
                                                label={item.label}
                                            />
                                        );
                                    })
                                    : null}
                            </CustomRadioGroup>
                        </CustomBox>
                    </CustomPopover>
                    <CustomDivider className={avatarClasses.divider} orientation="vertical" />
                    <CustomInputBase
                        className={clsx(
                            classes.input,
                            props && props.size && props.size === "small"
                                ? classes.inputSmall
                                : null
                        )}
                        value={searchKey}
                        onChange={(e) => handleSearchChange(e)}
                        placeholder={dropdownValue.placeholder}
                        inputProps={{ "aria-label": dropdownValue.placeholder }}
                    />
                    <CustomIconButton
                        onClick={getSearchResult}
                        className={classes.iconButton}
                        aria-label="search"
                    >
                        <img
                            src={SearchIcon}
                            alt="Down Arrow"
                            className={classes.searchIcon}
                        />
                    </CustomIconButton>
                </CustomPaper>
                <CustomPaper
                    component="div"
                    className={clsx(
                        classes.searchResultWrapper,
                        props && props.size && props.size === "small"
                            ? classes.smallSearchResultWrapperOpen
                            : null,
                        searchResultPopoverOpen ? classes.searchResultWrapperOpen : null
                    )}
                    square
                    elevation={0}
                >
                    {!isApi &&
                        !isApiFailed &&
                        searchSuggestionData &&
                        searchSuggestionData.length ? (
                        <>
                            <CustomBox
                                component="div"
                                className={clsx(classes.searchResultListWrapper)}
                            >
                                {searchSuggestionData.map((item, index) => {
                                    return (
                                        <Link
                                            to={
                                                item.searchType === parseInt(SearchCriteria.Groups)
                                                    ? `/admin/groups/view/${item.id}`
                                                    // `/admin/`
                                                    : item.searchType === parseInt(SearchCriteria.Users)
                                                        ? `/admin/users/${item.id}`
                                                        : ""
                                            }
                                            key={`${index}-searchResultRow-${item.resultType}-${item.id}`}
                                            className={clsx(
                                                classes.searchItem,
                                                item && item.resultType === 2
                                                    ? classes.searchItemIsGroup
                                                    : null
                                            )}
                                        >
                                            <CustomBox className={avatarClasses.root}>
                                                <CustomAvatar className={avatarClasses.searchAvatar} variant="circular" >
                                                    {item && item.name && getInitials(`${item.name}`)}
                                                </CustomAvatar>
                                            </CustomBox>
                                            <CustomBox className={classes.searchName}>
                                                {item.name}
                                            </CustomBox>
                                            <CustomBox className={classes.searchStatus}>
                                                <Trans
                                                    i18nKey={`USER_STATUS_${Object.keys(RecordStatus).find(
                                                        (key) => RecordStatus[key] === item.recordStatus
                                                    )}`}
                                                >
                                                    {Object.keys(RecordStatus).find(
                                                        (key) => RecordStatus[key] === item.recordStatus
                                                    )}
                                                </Trans>
                                            </CustomBox>

                                            {item.userRoles && item.userRoles.length ? (
                                                <CustomBox className={classes.searchRole}>
                                                    <Trans
                                                        i18nKey={`ROLE_TITLE_${Object.keys(Role).find(
                                                            (key) => Role[key] === item.userRoles[0]
                                                        )}`}
                                                    >
                                                        {Object.keys(Role).find(
                                                            (key) => Role[key] === item.userRoles[0]
                                                        )}
                                                    </Trans>
                                                    {item.userRoles.length > 1
                                                        ? ` + ${item.userRoles.length - 1} ${t("ROLES")}`
                                                        : null}
                                                </CustomBox>
                                            ) : item.userCount ? (
                                                <CustomBox className={classes.searchRole}>
                                                    {t("USER_COUNT")}: {item.userCount}
                                                </CustomBox>
                                            ) : null}
                                        </Link>
                                    );
                                })}
                            </CustomBox>
                            {getRBAC_AdminSearchResultView &&
                                getRBAC_AdminSearchResultView.isAccessible ===
                                EntityAccess.ALLOWED ? (
                                <CustomBox
                                    className={clsx(
                                        classes.searchResultFooter,
                                        classes.searchItemMore
                                    )}
                                >
                                    <CustomBox
                                        onClick={getSearchResult}
                                        className={classes.searchMore}
                                    >
                                        {t("VIEW_ALL_RESULT")}
                                    </CustomBox>
                                </CustomBox>
                            ) : null}
                        </>
                    ) : isApi ? (
                        <CustomBox
                            className={clsx(
                                classes.searchResultFooter,
                                classes.searchItemNoResult
                            )}
                        >
                            <CustomCircularProgress />
                        </CustomBox>
                    ) : (
                        <CustomBox
                            className={clsx(
                                classes.searchResultFooter,
                                classes.searchItemNoResult
                            )}
                        >
                            {apiResponseMessage}
                        </CustomBox>
                    )}

                    {/* {!isApi &&
            !isApiFailed &&
            (!searchSuggestionData || !searchSuggestionData.length) ? (
            <CustomBox
              className={clsx(
                classes.searchResultFooter,
                classes.searchItemNoResult
              )}
            >
              No result found for your search criteria
            </CustomBox>
          ) : isApi ? (
            <CustomBox
              className={clsx(
                classes.searchResultFooter,
                classes.searchItemNoResult
              )}
            >
              <CustomCircularProgress />
            </CustomBox>
          ) : !isApi && isApiFailed ? (
            <CustomBox
              className={clsx(
                classes.searchResultFooter,
                classes.searchItemNoResult
              )}
            >
              Something went wrong, please try after sometime
            </CustomBox>
          ) : null} */}
                </CustomPaper>
            </CustomBox>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </div>
    );
}
